import type { OfferView } from '@/api/generated';
import { moneyIn } from '@/components/moneyIn';

export function offerPeriodLabel(
  interval: OfferView['interval'] | undefined,
  perMonth: string,
  perYear: string,
): string {
  return interval === 'YEAR' ? perYear : perMonth;
}

export function offerLabel(
  offer: OfferView | undefined,
  currency: string,
  locale: string,
  perPeriod: string,
  unavailable: string,
): string {
  if (offer?.baseRetailMinor === undefined) return unavailable;
  const money = moneyIn(offer.baseRetailMinor, currency, locale, unavailable);
  if (money === unavailable) return unavailable;
  return `${money} ${perPeriod}`;
}

export function offerById(offers: OfferView[] | undefined, id: number | undefined): OfferView | undefined {
  if (id === undefined) return undefined;
  return offers?.find((offer) => offer.id === id);
}
